import MLinkContainer from './index.vue';

MLinkContainer.install = app => {
  app.component(MLinkContainer.name, MLinkContainer);
};

export default MLinkContainer;
